// extracted by mini-css-extract-plugin
export default {"topEventPopup":"TopEventPopup_topEventPopup__iH6my","Icon":"TopEventPopup_Icon__OQf4o"};